export default "__VITE_ASSET__CmhikLAH__"